<div class="ticket-list-item col pt-2 pb-3 {{ ('global_ticket_normalized_name_' + size) | resource }}">
    <div class="col-12">
        <div class="ticket-list-item-img pt-3">
            <div class="hide">
                <img [src]="'global_ticket_image_url_vert_' + name | resource" class="img-fluid" />
            </div>
        </div>
    </div>
    <div class="col-12 ticket-list-item-last">
        <div class="ticket-list-item-name mt-5">
            <h3>{{ 'global_share_type_name_' + name | resource }}</h3>
        </div>
        <div class="ticket-list-item-details">
            <div class="ticket-list-item-details-top">
                <div class="ticket-list-item-details-name d-inline">Topgevinst</div>
                <div
                    class="ticket-list-item-details-value ticket-list-item-details-value--highlight ticket-list-item-details-value--highlight--larger float-end">
                    <div *ngIf="shareType.Size > 0.25"><span class="amount">{{ shareType.Size * 200000000 | money:
                            true}}*</span></div>
                    <div *ngIf="shareType.Size <= 0.25"><span class="amount">{{ topPrize | money }}*</span></div>
                </div>
            </div>
            <div class="ticket-list-item-details-winchance ">
                <div class="ticket-list-item-details-name col-sm-6 d-inline">Vinderchance</div>
                <!-- Could use calcs to determine winchance - needs Share instead of ShareType  -->
                <!-- winchance always 41 % for 1 ticket -->
                <div
                    class="ticket-list-item-details-value ticket-list-item-details-value--highlight ticket-list-item-details-value--highlight--larger col-sm-6 float-end">
                    41%</div>
            </div>
        </div>
        <div class="ticket-list-item-last-btn w-100 pt-5">
            <button class="cta cta--primary mx-auto d-block mb-3 ps-2 pe-2" (click)="addShareTypeToOrder()">Køb
                {{
                'global_share_type_name_' + name | resource }}</button>
        </div>
    </div>
</div>